import { CUSTOMER_TYPE, ILabelForm, ILabelMutation } from 'services/labels/types';
import { isUnder18 } from 'utils/components/isUnder18';

export const labelFormToQuery = (labelForm: ILabelForm): ILabelMutation => {
  const { residenceCertificates, ...label } = {
    ...labelForm,
    ...(labelForm.customerType === CUSTOMER_TYPE.Company
      ? {
          personalIdCountryAlfa2: '',
          personalId: '',
        }
      : { companyCountryAlfa2: '', companyId: '' }),
    ...(labelForm.dateOfBirth && !isUnder18(labelForm.dateOfBirth)
      ? {
          legalSupervisorFirstName: '',
          legalSupervisorLastName: '',
          legalSupervisorPersonalId: '',
          legalSupervisorCountryAlfa2: '',
        }
      : {}),
    phoneNumberPrefix: `+${String(labelForm.phoneNumberPrefix ?? '').replace(/\+/g, '')}`,
    bankAccountNumber:
      labelForm.customerType === CUSTOMER_TYPE.Physical
        ? labelForm.bankAccountNumber.includes(labelForm.personalIdCountryAlfa2)
          ? labelForm.bankAccountNumber
          : labelForm.personalIdCountryAlfa2 + labelForm.bankAccountNumber
        : labelForm.bankAccountNumber.includes(labelForm.companyCountryAlfa2)
          ? labelForm.bankAccountNumber
          : labelForm.companyCountryAlfa2 + labelForm.bankAccountNumber,
  };

  return label;
};
